import { RouteEnum } from 'pro/config/routers';

export const CHECKOUT_LAYOUT_PATHS: string[] = [
    RouteEnum.CART,
    RouteEnum.CHECKOUT,
    RouteEnum.PAY
];